module.exports = __webpack_public_path__ + "static/img/active.61b7fb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/active.png
// module id = 6jCO
// module chunks = 1